import type { TrendResultT } from '@mentimeter/visualizations';
import type { Choice } from '../types';

export const trendsTestVotes = ({
  choices,
}: {
  choices: Choice[];
}): TrendResultT[] => {
  const NUMBER_OF_SESSIONS = 5;
  const sessions = [];

  for (let i = 0; i < NUMBER_OF_SESSIONS; i++) {
    const current = i === NUMBER_OF_SESSIONS - 1;
    const session = {
      id: i,
      label: current ? 'Current ' : `Session ${i + 1}`,
      current,
      data: {
        session: i,
        participantCount: 5,
        responses: choices.map((option, index) => ({
          id: index,
          title: option.label,
          responses: [Math.random() * 0.5 + (index + 5) * (Math.random() + 1)],
        })),
      },
    };
    sessions.push(session);
  }
  return sessions;
};
